import ReactDOM from 'react-dom/client';
import './index.css';
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import { Router } from './app/router/router';
import { Provider } from 'react-redux';
import store from './app/store/store';
import TechScreen from './pages/techScreen/TechScreen';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (process.env.REACT_APP_TECH_SCREEN === 'true') {
  root.render(
    <TechScreen />
  );
} 
else {
  const browserRouter = createBrowserRouter(Router);

  root.render(
    <Provider store={store}>
      <RouterProvider router={browserRouter} />
    </Provider>
  );
}
